import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/settings/categories";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/settings/dropdown/Category";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }


 
    getDropDown=(id)=>{
        if(id){
            return  http.get(`${apiDropDownEndpoint}?status=1&building_ids=${id}`) 
        }else{
            return  http.get(`${apiDropDownEndpoint}?status=1`) 
        }
      
    }
 
   

}
